import * as THREE from 'three';
import gsap from 'gsap';

export class Scene {
    
    setUp(e) {
  
      this.e=e;

    }
  
    buildScene(){

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.modelMode = urlParams.get('model');

      //---------------------------------------------------------

      this.mainCont = new THREE.Group();
      this.e.scene3D.add(this.mainCont)

      this.dl = new THREE.DirectionalLight(0xffffff, 5);
      this.dl.position.x=12*3;
      this.dl.position.z=26*3;
      this.dl.position.y=26*3;
      this.mainCont.add(this.dl);

      // this.dl_shad = new THREE.DirectionalLight(0xffffff, 1);
      // this.dl_shad.position.x=12*3;
      // this.dl_shad.position.z=26*3;
      // this.dl_shad.position.y=26*3;
      // this.mainCont.add(this.dl_shad);

      // this.dl_shad.castShadow=true;

      // this.dl_shad.shadow.mapSize.width = 1024;
      // this.dl_shad.shadow.mapSize.height = 1024;
      // // this.dl_shad.shadow.bias = .001;
      
      // this.e.sSize = 11;
      // this.dl_shad.shadow.camera.near = 0.1; 
      // this.dl_shad.shadow.camera.far = 180;
      // this.dl_shad.shadow.camera.left = -this.e.sSize;
      // this.dl_shad.shadow.camera.right = this.e.sSize;
      // this.dl_shad.shadow.camera.top = this.e.sSize;
      // this.dl_shad.shadow.camera.bottom = -this.e.sSize;
      // this.dl_shad.shadow.radius = 2;

      // const shadowHelper = new THREE.CameraHelper(this.dl_shad.shadow.camera);
      // this.mainCont.add(shadowHelper);

      // ambient light

      this.ambLight = new THREE.AmbientLight( 0xffffff, 1 );
      this.mainCont.add( this.ambLight );

      //---PLAYER------------------------------------------------------------------------------------------------------

      this.playerCont = new THREE.Group();
      this.mainCont.add(this.playerCont)
      this.playerCont.position.y=0;
      this.playerCont.position.z=0;
      this.playerCont.position.x=0;

      //---SCENE------------------------------------------------------------------------------------------------------

      var geometry = new THREE.PlaneGeometry(10,10);
      var material = new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0 });
      this.darkPlane = new THREE.Mesh(geometry, material);
      this.darkPlane.position.z=-5;
      this.mainCont.add(this.darkPlane);

      this.downAmount = -4.3;

      //--------------------------------------------------------

      this.boost = new THREE.Group();
      this.mainCont.add(this.boost)
      this.boost.rotation.y = this.e.u.ca(58);
      this.boost.position.z=-10;
      this.boost.position.y=this.downAmount;

      this.boost1 = this.e.boost.clone();
      this.boost1.scale.x = this.boost1.scale.y = this.boost1.scale.z = 3;
      this.boost.add(this.boost1);
      this.boost1Mats = [];

      this.boost1.traverse((object) => {

        if ( object.isMesh ){

          console.log(object.name);

          if(object.name==="pegsLeft"){

            this.pegsLeft2 = object;

          }else if(object.name==="pegsRight"){

            this.pegsRight2 = object;

          }else if(object.name==="feet"){

            this.feet = object;
            // this.feet.scale.x = this.feet.scale.y = this.feet.scale.z = 1; 
            object.material = new THREE.MeshStandardMaterial({ color: 0x303030, opacity: 1, metalness: 0, roughness: .5 });

          }else if(object.name==="mount"){

            object.material = new THREE.MeshStandardMaterial({ transparent: true, opacity: 1, color: 0x000000});
            
            this.mount=object;
  
          }else if(object.name==="boost001" || object.name==="boost002" || object.name==="boost003" || object.name==="boost004"){

            this.boost1Mats.push(object);

          }

        }

      });

      this.mount2 = this.e.mount2.clone();
      this.mount2.scale.x = this.mount2.scale.y = this.mount2.scale.z = 3;
      this.mount2.rotation.y = this.e.u.ca(58);
      this.mount2.position.z=-10;
      this.mount2.position.y=this.downAmount;
      this.mainCont.add(this.mount2);

      //--------------------------------------------------------

      this.mountTop = this.e.mountTop.clone();
      this.mountTop.scale.x = this.mountTop.scale.y = this.mountTop.scale.z = 3;
      this.mountTop.rotation.y = this.e.u.ca(58);
      this.mountTop.position.z=-10;
      this.mountTop.position.y=this.downAmount;
      this.mainCont.add(this.mountTop);

      this.mountTop.traverse((object) => {

        if ( object.isMesh ){

          console.log(object.name);
          this.mountTopOb = object;
          this.mountTopOb.material.transparent=true;

        }

      });

      //--------------------------------------------------------

      this.boost2 = this.e.boost.clone();
      this.boost2.scale.x = this.boost2.scale.y = this.boost2.scale.z = 3;
      this.boost.add(this.boost2);
      this.boost2.position.z=.4;
      this.boost2Mats = [];

      this.boost2.traverse((object) => {

        if ( object.isMesh ){

          if(object.name==="pegsLeft"){

            object.material = new THREE.MeshStandardMaterial({ visible: false });

          }else if(object.name==="pegsRight"){

            object.material = new THREE.MeshStandardMaterial({ visible: false });

          }else if(object.name==="feet"){

            this.feet2 = object;
            object.material = new THREE.MeshStandardMaterial({ color: 0x303030, opacity: 1, metalness: 0, roughness: .5 });

          }else if(object.name==="mount"){

            object.position.y=-100;

          }else{

            var newMat = object.material.clone();
            object.material = newMat;
            this.boost2Mats.push( newMat );

          }

        }

      });

      //--------------------------------------------------------

      this.boost3 = this.e.boost.clone();
      this.boost3.scale.x = this.boost3.scale.y = this.boost3.scale.z = 3;
      this.boost.add(this.boost3);
      this.boost3.position.z=.8;
      this.boost3Mats = [];

      this.boost3.traverse((object) => {

        if ( object.isMesh ){

          if(object.name==="pegsLeft"){

            object.material = new THREE.MeshStandardMaterial({ visible: false });

          }else if(object.name==="pegsRight"){

            object.material = new THREE.MeshStandardMaterial({ visible: false });

          }else if(object.name==="feet"){

            this.feet3 = object;
            object.material = new THREE.MeshStandardMaterial({ color: 0x303030, opacity: 1, metalness: 0, roughness: .5 });

          }else if(object.name==="mount"){

            object.position.y=-100;

          }else{

            var newMat = object.material.clone();
            object.material = newMat;
            this.boost3Mats.push( newMat );

          }

        }

      });

      //--------------------------------------------------------

      this.feet2.material.visible = false;
      this.feet2.material.transparent = true;
      this.feet3.material.visible = false;
      this.feet3.material.transparent = true;

      for(var i=0; i<this.boost2Mats.length; i++){
        this.boost2Mats[i].visible=false;
        this.boost2Mats[i].transparent=true;
      }

      for(var i=0; i<this.boost3Mats.length; i++){
        this.boost3Mats[i].visible=false;
        this.boost3Mats[i].transparent=true;
      }

      //--------------------------------------------------------

      // this.myModel.materialArray = [...this.myModel.materialList];

      // console.log(this.myModel.materialList);

      this.pegsLeft2.material.transparent = true;
      this.pegsLeft2.material.opacity = 0;

      this.pegsRight2.material.transparent = true;
      this.pegsRight2.material.opacity = 0;

      // this.feet.material.transparent = true;
      // this.feet.material.opacity = 0;

      this.feet.position.y = -4.5;

      //--------------------------------------------------------

      this.pegs = this.e.peg.clone();
      this.pegs.scale.x = this.pegs.scale.y = this.pegs.scale.z = 3;
      this.pegs.position.y=this.downAmount;
      this.mainCont.add(this.pegs);
      this.pegs.rotation.y = this.e.u.ca(58);
      this.pegs.position.z=-10;

      this.pegs.traverse((object) => {

        if ( object.isMesh ){

          if(object.name==="pegsLeft"){

            this.pegsLeft = object;

          }else if(object.name==="pegsRight"){

            this.pegsRight = object;

          }

        }

      });

      this.pegsLeft.material.transparent = true;
      this.pegsRight.material.transparent = true;

      this.pegsLeft.material.opacity = 0;
      this.pegsRight.material.opacity = 0;

      //--------------------------------------------------------

      this.inverter = new THREE.Group();
      this.inverter.position.y=this.downAmount;
      this.inverter.rotation.y = this.e.u.ca(58);
      this.inverter.position.z=-10;
      // this.inverter.position.x=1;
      this.mainCont.add(this.inverter)

      this.inverter1 = this.e.inverter.clone();
      this.inverter1.scale.x = this.inverter1.scale.y = this.inverter1.scale.z = 3;
      // this.inverter1.position.y=this.downAmount;
      // this.inverter1.rotation.y = this.e.u.ca(58);
      // this.inverter1.position.z=-10;
      this.inverter.add(this.inverter1);

      this.inverter1Mats = [];
      this.inverter1.traverse((object) => {

        // console.log(object.name);

        if ( object.isMesh ){

          // console.log(">>> "+object.name);

          var newMat = object.material.clone();

          // console.log(this.modelMode);

          if(this.modelMode!=="inverter"){
            console.log("made trans")
            newMat.transparent=true;
          }else{
            newMat.transparent=false;
          }
          
          // newMat.opacity=.99;
          object.material = newMat;
          this.inverter1Mats.push( newMat );



        }

      });

      this.inverter2 = this.e.inverter.clone();
      this.inverter2.scale.x = this.inverter2.scale.y = this.inverter2.scale.z = 3;
      // this.inverter2.position.y=this.downAmount;
      // this.inverter2.rotation.y = this.e.u.ca(58);
      // this.inverter2.position.z=-10;
      this.inverter2.position.x=-2.5;
      this.inverter2.position.y=0;
      this.inverter.add(this.inverter2);

      this.inverter2Mats = [];
      this.inverter2.traverse((object) => {

        if ( object.isMesh ){

          var newMat = object.material.clone();
          object.material = newMat;
          object.material.transparent = true;
          object.material.visible = false;
          object.material.opacity = 0;
          this.inverter2Mats.push( newMat );
          
        }

      });

      //--------------------------------------------------------

      this.mountOb = this.e.mount.clone();
      this.mountOb.scale.x = this.mountOb.scale.y = this.mountOb.scale.z = 3;
      this.mountOb.position.y=this.downAmount;
      this.mountOb.rotation.y = this.e.u.ca(58);
      this.mountOb.position.z=-10;
      this.mainCont.add(this.mountOb);

      this.mountOb.traverse((object) => {

        if(object.name==="floor"){

          object.material.visible=false;

        }else if(object.name==="shadowBot"){

          object.material = new THREE.MeshStandardMaterial({ transparent: true, opacity: 0.5, color: 0x000000});
          this.shadowBot=object;

        }else if(object.name==="shadowTop"){

          object.material = new THREE.MeshStandardMaterial({ transparent: true, opacity: 0.5, color: 0x000000});
          this.shadowTop=object;

        }

      });

      //--------------------------------------------------------

      if(this.modelMode==="inverter"){
        this.myModel = this.inverter;
      }else{
        this.myModel = this.boost;
      }
      
      //--------------------------------------------------------

      this.count=0;
      this.action="wait"

      document.addEventListener("click", () => {

        if(this.action==="wait"){
          if(this.modelMode==="inverter"){
            this.action="start"
          }else{
            this.action="start boost"
          }
        }
        
      })

      this.isPaused=false;

      document.getElementById("pauseBut").addEventListener("click", () => {

        if(this.isPaused===false){
          this.isPaused=true;
          gsap.globalTimeline.pause();
          document.getElementById("pauseBut").innerHTML = "resume";
        }else{
          this.isPaused=false;
          gsap.globalTimeline.resume();
          document.getElementById("pauseBut").innerHTML = "pause";
        }
        
      });

    }

    update(){

      this.tweenInSpeed = 1;
      this.spinSpeed = 10;

      if(this.action==="wait"){

        //

      }else if(this.action==="start boost"){

        // gsap.to(this.pegsLeft.position, { duration: 1, x:-.2, ease: "sine.out" });
        // gsap.to(this.pegsRight.position, { duration: 1, x:.2, ease: "sine.out" });

        this.action="start boost wait"

      }else if(this.action==="start boost wait"){

        // this.count+=this.e.dt;
        // if(this.count>2){
          this.action="start";
        // }

      }else if(this.action==="start"){

        this.count=0;

        // for(var i=0; i<this.myModel.materialArray.length; i++){

        //   gsap.to(this.myModel.materialArray[i], { duration: this.tweenInSpeed, opacity: 1, ease: "linear" });

        // }

        if(this.modelMode!=="inverter"){

          console.log("not inv")

          gsap.to(this.mount2.position, { duration: this.tweenInSpeed, z: 0, y:-2, ease: "sine.out" });
          gsap.to(this.myModel.position, { duration: this.tweenInSpeed, z: 0, y:-2, ease: "sine.out" });
          gsap.to(this.shadowBot.material, { duration: this.tweenInSpeed/4, opacity: 0, ease: "sine.out" });

        }else{

          console.log("inv")

          gsap.to(this.mountTop.position, { duration: this.tweenInSpeed, z: 0, y:-4.9, ease: "sine.out" });
          gsap.to(this.myModel.position, { duration: this.tweenInSpeed, x:0, z: 0, y:-4.9, ease: "sine.out" });
          gsap.to(this.shadowTop.material, { duration: this.tweenInSpeed/4, opacity: 0, ease: "sine.out" });

        }

        document.getElementById("pauseBut").innerHTML = "pause";
        document.getElementById("pauseBut").style.pointerEvents = "auto";
        // gsap.to(document.getElementById("pauseBut"), { duration: this.tweenInSpeed/4, opacity: 1, ease: "linear" });

        gsap.to(this.darkPlane.material, { duration: 1, delay: .5, opacity: 0.8, ease: "linear" });
        this.action="start wait";

      }else if(this.action==="start wait"){

        this.count+=this.e.dt;
        if(this.count>this.tweenInSpeed){

          this.count=0;
          this.action="spin";

        }

      }else if(this.action==="spin"){

        console.log(this.myModel.position);

        if(this.modelMode==="inverter"){

          gsap.killTweensOf(this.mountTop.rotation);
          this.mountTop.rotation.y = this.e.u.ca(58);
          gsap.to(this.mountTop.rotation, { duration: this.spinSpeed, y: this.e.u.ca(58+360), ease: "sine.inOut" });
         
        }else{

          gsap.to(this.pegsLeft.material, { duration: 1, opacity:0, ease: "sine.out" });
          gsap.to(this.pegsRight.material, { duration: 1, opacity:0, ease: "sine.out" });
  
          gsap.killTweensOf(this.mount2.rotation);
          this.mount2.rotation.y = this.e.u.ca(58);
          gsap.to(this.mount2.rotation, { duration: this.spinSpeed, y: this.e.u.ca(58+360), ease: "sine.inOut" });
         
        }

        gsap.to(this.myModel.rotation, { duration: this.spinSpeed, y: this.e.u.ca(58+360), ease: "sine.inOut" });

        this.action="spin wait";

      }else if(this.action==="spin wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.spinSpeed){

          this.count=0;

          if(this.modelMode==="inverter"){
            this.action="out inverter"
          }else{
            this.action="pegs";
          }
          
        }

      }else if(this.action==="pegs"){

        this.pegsLeft2.position.x = -.5;
        this.pegsRight2.position.x = .5;

        this.pegsLeft2.material.opacity = 1;
        this.pegsRight2.material.opacity = 1;

        gsap.to(this.pegsLeft2.position, { duration: 1, x:0, ease: "sine.out" });
        gsap.to(this.pegsRight2.position, { duration: 1, x:0, ease: "sine.out" });

        this.count=0;
        this.action="pegs wait"

      }else if(this.action==="pegs wait"){

        this.count+=this.e.dt;

        if(this.count>2){

          this.count=0;
          this.action="feet"

        }

      }else if(this.action==="feet"){

          console.log(this.pegsLeft);
          console.log(this.pegsRight);

          // this.pegsLeft.position.x=2;

          // this.pegsLeft.material.opacity=0;
          // this.pegsRight.material.opacity=0;

          this.feet.material.transparent = true;
          this.feet.material.opacity = 1;
          this.feet.position.y = -.5;
          gsap.to(this.feet.position, { duration: 1, y:0, ease: "sine.out" });

          this.action="feet wait"
          this.count=0;

      }else if(this.action==="feet wait"){

        this.count+=this.e.dt;

        if(this.count>3){

          this.count=0;
          this.action="out"

        }

      }else if(this.action==="out"){

        document.getElementById("pauseBut").style.pointerEvents = "none";
        gsap.to(document.getElementById("pauseBut"), { duration: this.tweenInSpeed/4, opacity: 0, ease: "linear" });

        this.count=0;
        
        // if(this.modelMode==="inverter"){

        //   this.action="restore boost";
        //   this.inverter.rotation.y = this.e.u.ca(58);
        //   console.log(this.inverter1Mats);

        // }else{
            
          gsap.to(this.feet.material, { duration: 1, opacity:0, ease: "sine.out", onComplete: () => { this.feet.material.transparent = false; } });
          gsap.to(this.pegsLeft2.material, { duration: 1, opacity:0, ease: "sine.out" });
          gsap.to(this.pegsRight2.material, { duration: 1, opacity:0, ease: "sine.out" });

          gsap.to(this.shadowBot.material, { duration: .5, delay: .5, opacity: 0.5, ease: "linear" });
          gsap.to(this.shadowTop.material, { duration: .5, delay: .5, opacity: 0.5, ease: "linear" });
          
          console.log(this.boost.position.x);
          gsap.to(this.boost.position, { x: 1.5, duration: .5, delay: .5, ease: "linear" });

          // gsap.to(this.myModel.position, { duration: this.tweenInSpeed, delay: .5, z: -10, y: this.downAmount, ease: "sine.out" });

          gsap.to(this.darkPlane.material, { duration: this.tweenInSpeed/2, opacity: 0, ease: "sine.out" });

          this.pegsLeft.position.x=0;
          this.pegsRight.position.x=0;

          this.action="out wait";

        // }

      }else if(this.action==="out wait"){

        this.count+=this.e.dt;

        if(this.count>1){
          this.feet.material.transparent = false;
          this.feet.position.y = -4.5;
        }

        if(this.count>2){

          // gsap.to(this.pegsLeft.material, { duration: .3, delay: 1, opacity:1, ease: "sine.out" });
          // gsap.to(this.pegsRight.material, { duration: .3, delay: 1, opacity:1, ease: "sine.out" });
  
          this.myModel.rotation.y = this.e.u.ca(58);
          this.count=0;
          this.action="move mount";

        }

      }else if(this.action==="move mount"){

        gsap.to(this.mount2.position, { duration: this.tweenInSpeed, z: -10, y: this.downAmount, ease: "sine.out" });

        this.count=0;
        this.action="move boost wait"

      }else if(this.action==="move boost wait"){

        this.count+=this.e.dt;

        if(this.count>2){
          this.count=0;
          this.action="move boost back"
        }

      }else if(this.action==="move boost back"){

        gsap.to(this.boost.position, { duration: this.tweenInSpeed, x: 0, z: -10, y: this.downAmount, ease: "sine.out" });

        this.count=0;
        this.action="move boost back wait"

      }else if(this.action==="move boost back wait"){

        this.count+=this.e.dt;

        if(this.count>1){
          this.count=0;
          this.action="show boost2"
        }

      }else if(this.action==="show boost2"){

        this.rs = .3;

        for(var i=0; i<this.boost2Mats.length; i++){

          gsap.to(this.shadowBot.scale, { duration: this.rs, z:2, ease: "linear" });

          this.boost2Mats[i].opacity=0;
          this.boost2Mats[i].visible=true;
          gsap.to(this.boost2Mats[i], { duration: this.rs, opacity:1, ease: "linear" });

        }

        this.feet2.material.opacity=0;
        this.feet2.material.visible=true;
        gsap.to(this.feet2.material, { duration: this.rs, opacity:1, ease: "linear" });

        this.feet.position.y = 0;

        this.feet.material.opacity=0;
        this.feet.material.visible=true;
        gsap.to(this.feet.material, { duration: this.rs, opacity:1, ease: "linear" });

        console.log(this.mountTopOb);
        gsap.to(this.mountTopOb.material, { duration: this.rs, opacity:0, ease: "linear" });

        this.action="show boost2 wait"

      }else if(this.action==="show boost2 wait"){

        this.count+=this.e.dt;
        if(this.count>1){

          this.action="show boost3"
          this.count=0;

        }

      }else if(this.action==="show boost3"){

        //---------------------------------------

        for(var i=0; i<this.inverter1Mats.length; i++){

          this.inverter1Mats[i].opacity=1;
          this.inverter1Mats[i].transparent=true;
          this.inverter1Mats[i].visible=true;
          gsap.to(this.inverter1Mats[i], { duration: this.rs, opacity: 0, ease: "linear" });

        }

        for(var i=0; i<this.inverter2Mats.length; i++){

          this.inverter2Mats[i].opacity=0;
          this.inverter2Mats[i].transparent=true;
          this.inverter2Mats[i].visible=true;
          gsap.to(this.inverter2Mats[i], { duration: this.rs, opacity: 1, ease: "linear" });

        }

        gsap.to(this.shadowTop.material, { duration: this.rs, opacity:0, ease: "linear" });

        //---------------------------------------

        for(var i=0; i<this.boost3Mats.length; i++){

          gsap.to(this.shadowBot.scale, { duration: this.rs, z:3, ease: "linear" });

          this.boost3Mats[i].opacity=0;
          this.boost3Mats[i].visible=true;
          gsap.to(this.boost3Mats[i], { duration: this.rs, opacity:1, ease: "linear" });
          
        }

        this.feet3.material.opacity=0;
        this.feet3.material.visible=true;
        gsap.to(this.feet3.material, { duration: this.rs, opacity:1, ease: "linear" });

        this.action="show boost3 wait"

      }else if(this.action==="show boost3 wait"){

        this.count+=this.e.dt;
        if(this.count>6){

          this.action="show boost3 time"
          this.count=0;

        }

      }else if(this.action==="show boost3 time"){

        this.rs = .3;

        //---------------------------------------

        for(var i=0; i<this.inverter1Mats.length; i++){

          gsap.to(this.inverter1Mats[i], { duration: this.rs, opacity: 1, ease: "linear" });

        }

        for(var i=0; i<this.inverter2Mats.length; i++){

          this.inverter2Mats[i].opacity=0;
          this.inverter2Mats[i].transparent=true;
          this.inverter2Mats[i].visible=true;
          gsap.to(this.inverter2Mats[i], { duration: this.rs, opacity: 0, ease: "linear" });

        }

        gsap.to(this.shadowTop.material, { duration: this.rs, opacity: .5, ease: "linear" });

        //---------------------------------------

        for(var i=0; i<this.boost2Mats.length; i++){

          gsap.to(this.shadowBot.scale, { duration: this.rs, z:1, ease: "linear" });

          this.boost2Mats[i].opacity=0;
          this.boost2Mats[i].visible=true;
          gsap.to(this.boost2Mats[i], { duration: this.rs, opacity:0, ease: "linear" });
          
        }

        this.feet2.material.opacity=0;
        this.feet2.material.visible=true;
        gsap.to(this.feet2.material, { duration: this.rs, opacity:0, ease: "linear" });

        //---------------------------------------

        this.shadowBot.scale.z=1;

        for(var i=0; i<this.boost3Mats.length; i++){

          // gsap.to(this.shadowBot.scale, { duration: this.rs, z:1, ease: "linear" });

          this.boost3Mats[i].opacity=0;
          this.boost3Mats[i].visible=true;
          gsap.to(this.boost3Mats[i], { duration: this.rs, opacity:0, ease: "linear" });
          
        }

        this.feet3.material.opacity=0;
        this.feet3.material.visible=true;
        gsap.to(this.feet3.material, { duration: this.rs, opacity:0, ease: "linear" });

        gsap.to(this.mountTopOb.material, { duration: this.rs, opacity:1, ease: "linear" });
        this.mountTopOb.material.visible=true;
        this.feet.position.y = -4.5;

        //---------------------------------------

        this.action="restore boost"

      }else if(this.action==="out inverter"){

        this.action="out inverter wait";
        
      }else if(this.action==="out inverter wait"){

        this.count+=this.e.dt;
        if(this.count>1){

          this.action="inverter forward"
          this.count=0;

        }

        //------------------------------------------------

      }else if(this.action==="inverter forward"){

        gsap.to(this.myModel.position, { duration: this.tweenInSpeed, delay: 1, x: 2, ease: "sine.out" });

        this.action="inverter forward wait"

      }else if(this.action==="inverter forward wait"){

        this.count+=this.e.dt;
        if(this.count>2){

          this.action="inverter mount back"
          this.count=0;

        }

        //------------------------------------------------

      }else if(this.action==="inverter mount back"){

        gsap.to(this.darkPlane.material, { duration: this.tweenInSpeed/2, opacity: 0, ease: "sine.out" });

        gsap.to(this.mountTop.position, { duration: this.tweenInSpeed, z: -10, y:this.downAmount, delay: .5, ease: "sine.out" });

        this.action="inverter mount wait";

      }else if(this.action==="inverter mount wait"){

        this.count+=this.e.dt;
        if(this.count>2){

          this.action="inverter back"
          this.count=0;

        }

        //------------------------------------------------

      }else if(this.action==="inverter back"){

        gsap.to(this.myModel.position, { duration: this.tweenInSpeed, delay: .5, x: 0, z: -10, y: this.downAmount, ease: "sine.out" });

        this.action="inverter back wait"

      }else if(this.action==="inverter back wait"){

        this.count+=this.e.dt;
        if(this.count>2){

        this.inverter.rotation.y = this.e.u.ca(58);
        this.mountTop.rotation.y = this.e.u.ca(58);

          this.action="restore boost"
          this.count=0;

        }

      }else if(this.action==="restore boost"){

        this.count+=this.e.dt;
        if(this.count>1){

          this.action="wait"
          this.count=0;

        }

        
      }

      if(this.darkPlane.material.opacity===0){
        this.darkPlane.material.visible=false;
      }else{
        this.darkPlane.material.visible=true;
      }

      // this.mixer()

    }

        //------------------------------------------------------------------

        

    mixer(){

      if(document.getElementById("mix").checked === true){
  
          //-------------------------------------
  
          var c1_H = document.getElementById("c1_H").value;
          var c1_S = document.getElementById("c1_S").value;
          var c1_L = document.getElementById("c1_L").value;
  
          document.getElementById("c1_Color").value = this.e.u.hslToHex(c1_H,c1_S,c1_L);
          // this.rig.material.color.setHex( "0x"+this.e.u.hslToHex(c1_H,c1_S,c1_L) );
  
          //-------------------------------------
  
          var c2_H = document.getElementById("c2_H").value;
          var c2_S = document.getElementById("c2_S").value;
          var c2_L = document.getElementById("c2_L").value;
  
          document.getElementById("c2_Color").value = this.e.u.hslToHex(c2_H,c2_S,c2_L);
          // this.roofBars.material.color.setHex( "0x"+this.e.u.hslToHex(c2_H,c2_S,c2_L) );
          
          //-------------------------------------
  
          var c3_H = document.getElementById("c3_H").value;
          var c3_S = document.getElementById("c3_S").value;
          var c3_L = document.getElementById("c3_L").value;
  
          document.getElementById("c3_Color").value = this.e.u.hslToHex(c3_H,c3_S,c3_L);
          // this.roofEdge.material.color.setHex( "0x"+this.e.u.hslToHex(c3_H,c3_S,c3_L) );
          
          //-------------------------------------
  
          var c4_H = document.getElementById("c4_H").value;
          var c4_S = document.getElementById("c4_S").value;
          var c4_L = document.getElementById("c4_L").value;
  
          document.getElementById("c4_Color").value = this.e.u.hslToHex(c4_H,c4_S,c4_L);
          // this.ambLight.color.setHex( "0x"+this.e.u.hslToHex(c4_H,c4_S,c4_L) );
  
          //-------------------------------------
  
          var c5_H = document.getElementById("c5_H").value;
          var c5_S = document.getElementById("c5_S").value;
          var c5_L = document.getElementById("c5_L").value;
  
          document.getElementById("c5_Color").value = this.e.u.hslToHex(c5_H,c5_S,c5_L);
  
          //-------------------------------------
  
          var num1 = document.getElementById("num1").value;
          var num2 = document.getElementById("num2").value;
          var num3 = document.getElementById("num3").value;
  
          // this.dl_shad.position.x = num1;
          // this.dl_shad.position.z = num2;
          // this.dl_shad.position.y = num3;
  
      }

    }

}